import { Component, ElementRef, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-modal-purchase-order',
  template: `
    <ng-template #modalPurchaseOrder let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Agregar Orden de compra</h4>
        <button type="button" class="close btn btn-link" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-4">
        <form [formGroup]="purchaseOrderForm" (ngSubmit)="savePurchaseOrder()">
          <div class="form-group mt-4">
            <label for="reference" class="form-control-label">Referencia</label>
            <input type="text" class="form-control" formControlName="reference" placeholder="">
            <div *ngIf="ff['reference'].touched && ff['reference'].invalid">
              <div *ngIf="ff['reference'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="description" class="form-control-label">Descripción</label>
            <input type="text" class="form-control" formControlName="description" placeholder="">
            <div *ngIf="ff['description'].touched && ff['description'].invalid">
              <div *ngIf="ff['description'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="supplier" class="form-control-label">Proveedor</label>
            <select class="form-select" formControlName="supplier">
              <option value="" disabled selected>Selecciona un proveedor</option>
              <option *ngFor="let provider of providers" [value]="provider.pk">{{ provider.name }}</option>
            </select>
            <div *ngIf="ff['supplier'].touched && ff['supplier'].invalid">
              <div *ngIf="ff['supplier'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="supplier_reference" class="form-control-label">Referencia proveedor</label>
            <input type="text" class="form-control" formControlName="supplier_reference" placeholder="">
            <div *ngIf="ff['supplier_reference'].touched && ff['supplier_reference'].invalid">
              <div *ngIf="ff['supplier_reference'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="order_currency" class="form-control-label">Moneda</label>
            <input type="text" class="form-control" formControlName="order_currency" placeholder="">
            <div *ngIf="ff['order_currency'].touched && ff['order_currency'].invalid">
              <div *ngIf="ff['order_currency'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="target_date" class="form-control-label">Fecha estimada</label>
            <input type="date" class="form-control" formControlName="target_date" placeholder="">
            <div *ngIf="ff['target_date'].touched && ff['target_date'].invalid">
              <div *ngIf="ff['target_date'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="responsible" class="form-control-label">Responsable</label>
            <input type="text" class="form-control" formControlName="responsible" placeholder="">
            <div *ngIf="ff['responsible'].touched && ff['responsible'].invalid">
              <div *ngIf="ff['responsible'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
            </div>
          </div>
          <div class="form-group mt-4 text-end">
            <button type="submit" class="btn btn-zazz-dark">Guardar</button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styles: [
  ]
})
export class ModalPurchaseOrderComponent {
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalPurchaseOrder') modalPurchaseOrder !: ElementRef;

  providers: any[] = [];

  private modalRef: NgbModalRef | undefined;
  purchaseOrderForm: FormGroup = new FormGroup({});

  constructor(
    private inventoryService: InventoryService,
    private modalService: NgbModal,
    private fb: FormBuilder,
  ) {
    this.initForm();
    this.loadProviders();
  }

  initForm() {
    this.purchaseOrderForm = this.fb.group({
      reference: [''],
      description: [''],
      supplier: [''],
      supplier_reference: [''],
      order_currency: [''],      
      target_date: [''],
      total_price: [''],
      responsible: [''],
    });
  }

  get ff() {
    return this.purchaseOrderForm.controls
  }

  loadProviders() {
    this.inventoryService.getSuppliers({}).subscribe((res: any) => {
      console.log("PROVIDERS ===> ", res);
      this.providers = res.data;
    });
  }

  savePurchaseOrder() {

    console.log("SAVE ===> ", this.purchaseOrderForm.value);

    // if (this.purchaseOrderForm.invalid) {
      // this.purchaseOrderForm.markAllAsTouched();
      // return;
    // }

    this.inventoryService.createPurchaseOrder({ purchaseOrder: this.purchaseOrderForm.value }).subscribe({
      next: (res: any) => {},
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent, { size: 'lg' });
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
